import React, { useEffect, useState } from 'react'
import API from '../methods/API'
import ReportCard from '../components/ReportCard'
import Table from '../components/core/table/Table'
import CONSTANTS from '../CONSTANTS'
import serviceReportMethods from '../methods/serviceReportMethods'
import common from '../methods/common'
// import sampleList from "./sampleList.json"

const ServiceReportsList = () => {
    const [reports, setReports] = useState([])

    const cardView = false
    useEffect(() => {
        // getReports()
        if(!reports.length){
            getServicesByMail()

        }
    }, [reports.length])

    const deleteReport = async (id) => {
        await API.deleteReport(id)
        getReports()

    }
    const getReports = async () => {
        await API.getreports().then((data) => {
            setReports(prev=>([...prev, ...data]))
        }).catch((err) => {
            console.log(err)
            // setReports(sampleList)
        })
    }
    const getServicesByMail = async ()=>{
        await API.getServicesByMail().then((data) => {
            // setReports(data)
            setReports(prev=>([...prev, ...serviceReportMethods.modifyServiceForReports(data)]))
        }).catch((err) => {
            console.log(err)
            // setReports(sampleList)
        })
    }
    if (cardView) {
        return (
            <div className='reportlist'>
                {reports.map(report => <ReportCard report={report} deleteReport={deleteReport} />)}
            </div>
        )
    } else {
        return (
            <div className=''>

                {/* <Table
                    colms={CONSTANTS.SERVICE_LIST_TABLE.HEADS}
                    items={common.getUniqueById(serviceReportMethods.getModifiedReportsList(reports))}
                    heading={CONSTANTS.SERVICE_LIST_TABLE.TITLE}
                /> */}

                <Table
                    colms={CONSTANTS.SERVICE_LIST_TABLE_NEW.HEADS}
                    items={common.removeDuplicateService(serviceReportMethods.getModifiedReportsList(reports))}
                    heading={CONSTANTS.SERVICE_LIST_TABLE_NEW.TITLE}
                />

            </div>
        )
    }
}

export default ServiceReportsList
